import { Box, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ArrayField, Datagrid, FunctionField, NumberField, ReferenceField, SimpleShowLayout } from "react-admin";
import { Currency } from "utils/constants";
import { SectionTitle } from "features/SectionTitle";

const TaxesShow = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Такси"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
        <ArrayField
          source="taxes"
          label=" "
        >
          <Datagrid
            rowClick={false}
            bulkActionButtons={false}
            sx={settings.style.secondaryLeftAlignedDatagrid}
          >
            <ReferenceField
              source="taxTypeId"
              label="Такса"
              reference={administrationRequests.getTaxTypesSelect()}
            />
            <FunctionField
              render={record => {
                if (record.taxSource === "speciality_id") {
                  return (
                    <ReferenceField
                      source="taxSourceValue"
                      // label="Такса"
                      reference={administrationRequests.getSpecialitiesSelect()}
                    />
                  );
                } else if (record.taxSource === "exams_count") {
                  return `Брой изпити: ${record.taxSourceValue}`;
                }
              }}
              label=" "
            />

            <NumberField
              source="priceLeva"
              label="Цена в лева"
              options={{
                style: "currency",
                currency: Currency.BGN,
                minimumFractionDigits: 2,
              }}
              textAlign="left"
            />
            <NumberField
              source="priceEuro"
              label="Цена в евро"
              alignContent={"left"}
              options={{
                style: "currency",
                currency: Currency.EUR,
                minimumFractionDigits: 2,
              }}
              textAlign="left"
            />
          </Datagrid>
        </ArrayField>
      </Box>
    </SimpleShowLayout>
  );
};

export default TaxesShow;
